import { render, staticRenderFns } from "./poPerson.vue?vue&type=template&id=b5729400&scoped=true"
import script from "./poPerson.vue?vue&type=script&lang=js"
export * from "./poPerson.vue?vue&type=script&lang=js"
import style0 from "./poPerson.vue?vue&type=style&index=0&id=b5729400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5729400",
  null
  
)

export default component.exports